export function manageFiberPopin() {

    document.addEventListener('DOMContentLoaded', function() {
        toggleTabs();
        addCssForBbCodeList();
        dispatchResizeEventForMenuPage();
    });

    function dispatchResizeEventForMenuPage() {
        $('#about-fiber-popin').on('shown.bs.modal', event => {
            window.dispatchEvent(new Event('resize'));
        });
    }

    function addCssForBbCodeList(){
        const ulElements = document.querySelectorAll('.step-insert-text ul');

        ulElements.forEach(function(ulElement) {
            ulElement.classList.add('mb-0');
        });
    }
    function toggleTabs() {
        document.querySelectorAll('[data-fiber-popin-tab]').forEach(function(link) {
            link.addEventListener('click', function() {
                var targetTabId = link.getAttribute('data-fiber-popin-tab');

                document.querySelectorAll('[data-fiber-popin-tab]').forEach(function(tabLink) {
                    var tabId = tabLink.getAttribute('data-fiber-popin-tab');
                    document.getElementById(tabId).hidden = true;
                });

                document.getElementById(targetTabId).hidden = false;
            });
        });
    }
}
